<app-alert></app-alert>
<app-loading-modal></app-loading-modal>
<app-qrcode></app-qrcode>

<div class="flex min-h-[calc(100vh-48px)] flex-col gap-5 bg-light-color px-6 py-6 font-base text-dark-color">
  <header class="flex flex-col gap-4 rounded-2xl bg-gradient-to-r from-[var(--primary-color)] via-[var(--primary-color-hover)] to-[var(--second-color)] px-6 py-6 text-light-color shadow-[0_14px_40px_var(--box-shadow-color)] md:flex-row md:items-start md:justify-between md:gap-6">
    <div class="flex flex-col gap-2">
      <p class="text-xs uppercase tracking-[0.12em] text-light-color/80">Canais</p>
      <h1 class="text-2xl font-semibold leading-tight">Gerencie suas filas de envio</h1>
      <p class="max-w-3xl text-sm text-light-color/90">
        Cadastre novas filas, ajuste a taxa de disparo e monitore o status de conexão de cada canal.
      </p>
    </div>
    <div class="grid grid-cols-2 gap-3 text-sm md:grid-cols-2">
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Canais liberados</p>
        <strong class="text-lg">{{ infoChannels.canaisLiberados || 0 }}</strong>
      </div>
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Canais cadastrados</p>
        <strong class="text-lg">{{ infoChannels.canaisCadastrados || 0 }}</strong>
      </div>
    </div>
  </header>

  <section class="flex flex-col gap-3 rounded-xl border border-border-color bg-white px-5 py-5 shadow-[0_12px_36px_var(--box-shadow-color)]">
    <div class="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <div class="flex items-center gap-2 text-sm text-dark-color">
        <mat-icon>router</mat-icon>
        <span>Gerencie filas de disparo e integrações.</span>
      </div>
      <div class="flex gap-2">
        <button
          type="button"
          class="inline-flex items-center gap-2 rounded-base bg-primary-color px-4 py-3 text-sm font-semibold text-white shadow-md transition hover:bg-primary-hover"
          (click)="openModalRegisterQueue()">
          <mat-icon>add</mat-icon>
          Nova fila
        </button>
        <button
          type="button"
          class="inline-flex items-center gap-2 rounded-base bg-dark-color px-4 py-3 text-sm font-semibold text-white opacity-50"
          disabled>
          <mat-icon>mail</mat-icon>
          Nova fila email
        </button>
      </div>
    </div>

    <div class="overflow-hidden rounded-xl border border-border-color">
      <table class="min-w-full divide-y divide-border-color text-sm">
        <thead class="bg-light-color/60">
          <tr>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Nome</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">ID Fila</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">API Key</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Disparos/min</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Tipo</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Status</th>
            <th class="px-4 py-3 text-right font-semibold text-dark-color">Ações</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-border-color">
          <tr *ngIf="isLoadingClients">
            <td colspan="7" class="px-4 py-4 text-center text-dark-color/70">Carregando...</td>
          </tr>
          <tr
            *ngFor="let canal of listChannels"
            class="hover:bg-light-color/60 transition">
            <td class="px-4 py-3 text-dark-color">{{ canal.nomefila }}</td>
            <td class="px-4 py-3 text-dark-color">{{ canal.queueId }}</td>
            <td class="px-4 py-3 text-dark-color break-all">{{ canal.apiKey }}</td>
            <td class="px-4 py-3 text-dark-color">
              <div class="flex items-center gap-2">
                <span>{{ canal.fire }} p/min</span>
                <button
                  type="button"
                  class="flex h-8 w-8 items-center justify-center rounded-lg border border-border-color text-dark-color transition hover:border-primary-color hover:text-primary-color"
                  (click)="openModalEditFireQueue(canal)">
                  <mat-icon>edit</mat-icon>
                </button>
              </div>
            </td>
            <td class="px-4 py-3 text-dark-color">
              <span
                class="inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold"
                [ngClass]="canal.type === 'APIOFICIAL' ? 'bg-primary-color/10 text-primary-color' : 'bg-dark-color/10 text-dark-color'">
                <mat-icon class="text-sm">{{ canal.type === 'APIOFICIAL' ? 'api' : 'send' }}</mat-icon>
                {{ canal.type }}
              </span>
            </td>
            <td class="px-4 py-3 text-dark-color">
              <span
                class="inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold"
                [ngClass]="canal.status === 'Conectado' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'"
                [title]="canal.status === 'Conectado' ? 'Fila conectada' : 'Fila desconectada'">
                <mat-icon>{{ canal.status === 'Conectado' ? 'check_circle' : 'cancel' }}</mat-icon>
                {{ canal.status }}
              </span>
            </td>
            <td class="px-4 py-3 text-right">
              <div class="flex justify-end gap-2">
                <button
                  type="button"
                  class="flex h-10 w-10 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color hover:text-primary-color"
                  [style.cursor]="canal.status === 'Conectado' ? 'not-allowed' : 'pointer'"
                  (click)="generateQrCode(canal)">
                  <mat-icon>qr_code_scanner</mat-icon>
                </button>
                <button
                  type="button"
                  class="flex h-10 w-10 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-hover hover:text-primary-hover"
                  (click)="openModalDeleteQueue(canal)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="!isLoadingClients && listChannels.length === 0">
            <td colspan="7" class="px-4 py-6 text-center text-dark-color/70">
              Nenhum canal cadastrado.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>

<ng-container *ngIf="modalRegisterQueue">
  <div class="fixed inset-0 z-30 flex items-center justify-center bg-black/50 px-4">
    <div class="relative w-full max-w-3xl rounded-2xl border border-border-color bg-white shadow-2xl max-h-[90vh] overflow-y-auto">
      <div class="flex items-start justify-between border-b border-border-color px-5 py-4 sticky top-0 bg-white">
        <div>
          <p class="text-xs uppercase tracking-[0.12em] text-primary-color">Cadastro</p>
          <h3 class="text-lg font-semibold text-dark-color m-0">Nova fila</h3>
          <p class="text-sm text-dark-color/70 m-0">Configure nome, credenciais e taxa de disparo.</p>
        </div>
        <button type="button" class="rounded-lg p-2 text-dark-color/70 hover:bg-light-color/70" (click)="closeModalRegisterQueue()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="p-5">
        <form class="grid grid-cols-1 gap-4 md:grid-cols-2" [formGroup]="formRegisterQueue" (ngSubmit)="sendRegistrarCanal()">
          <div class="flex flex-col gap-2">
            <label class="text-sm text-dark-color">Nome da fila</label>
            <input type="text" class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" formControlName="nomefila" placeholder="Nome" />
          </div>
          <div class="flex flex-col gap-2">
            <label class="text-sm text-dark-color">ID da fila</label>
            <input type="text" class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" formControlName="queueId" placeholder="ID da fila" />
          </div>
          <div class="flex flex-col gap-2">
            <label class="text-sm text-dark-color">API Key</label>
            <input type="text" class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" formControlName="apiKey" placeholder="ApiKey" />
          </div>
          <div class="flex flex-col gap-2">
            <label class="text-sm text-dark-color">Tipo</label>
            <select class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" formControlName="type" (change)="alterType()">
              <option value="NORMAL">Normal</option>
              <option value="APIOFICIAL">Api Oficial</option>
            </select>
          </div>
          <div class="col-span-1 md:col-span-2 flex flex-col gap-2">
            <div class="flex items-center justify-between text-sm text-dark-color">
              <span>Disparos por minuto</span>
              <span class="rounded-full bg-primary-color/10 px-3 py-1 text-xs font-semibold text-primary-color">{{ formRegisterQueue.value.fire }}</span>
            </div>
            <input
              type="range"
              [min]="dataRange.min"
              [max]="dataRange.max"
              class="w-full accent-primary-color"
              formControlName="fire" />
            <p class="m-0 text-xs text-dark-color/70">Canais normais: 1 a 6 mensagens/min. API oficial: 1 a 200.</p>
          </div>

          <div class="col-span-1 md:col-span-2 mt-2 flex justify-end gap-2">
            <button type="button" class="rounded-base border border-border-color bg-dark-color px-4 py-2 text-sm text-white transition hover:border-primary-color" (click)="closeModalRegisterQueue()">
              Cancelar
            </button>
            <button type="submit" class="rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover disabled:cursor-not-allowed disabled:opacity-70" [disabled]="!formRegisterQueue.valid">
              Salvar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="modalEditFireQueue">
  <div class="fixed inset-0 z-30 flex items-center justify-center bg-black/50 px-4">
    <div class="w-full max-w-xl rounded-xl bg-white p-6 shadow-2xl">
      <div class="flex items-center justify-between border-b border-border-color pb-3">
        <div>
          <p class="text-xs uppercase tracking-[0.12em] text-primary-color">Editar fila</p>
          <h3 class="text-lg font-semibold text-dark-color">{{ clientEditFireSelected?.nomefila }}</h3>
        </div>
        <button type="button" class="text-dark-color/70 transition hover:text-dark-color" (click)="closeModalEditFireQueue()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <form class="mt-4 flex flex-col gap-4" [formGroup]="formEditFireQueue">
        <label class="flex flex-col gap-2 text-sm text-dark-color">
          Disparos por minuto
          <input
            type="range"
            [min]="rangesFireSelected.min"
            [max]="rangesFireSelected.max"
            class="w-full accent-primary-color"
            formControlName="fire" />
        </label>
        <div class="text-sm text-dark-color/80">Valor atual: {{ formEditFireQueue.get('fire')?.value }}</div>

        <div class="flex justify-end gap-2">
          <button type="button" class="rounded-base border border-border-color bg-dark-color px-4 py-2 text-sm text-white transition hover:border-primary-color" (click)="closeModalEditFireQueue()">
            Cancelar
          </button>
          <button type="button" class="rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover" (click)="sendEditFireQueue()">
            Salvar
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="modalDeleteQueue">
  <div class="fixed inset-0 z-30 flex items-center justify-center bg-black/50 px-4">
    <div class="w-full max-w-md rounded-xl bg-white p-6 shadow-2xl">
      <div class="flex items-center justify-between border-b border-border-color pb-3">
        <h3 class="text-lg font-semibold text-dark-color">Confirmar exclusão</h3>
        <button type="button" class="text-dark-color/70 transition hover:text-dark-color" (click)="closeModalDeleteQueue()">&times;</button>
      </div>
      <div class="py-4 text-sm text-dark-color/80">
        <p>Tem certeza de que deseja excluir este canal?</p>
        <p>Esta ação não pode ser desfeita.</p>
      </div>
      <div class="flex justify-end gap-2">
        <button class="rounded-base border border-border-color bg-dark-color px-4 py-2 text-sm text-white transition hover:border-primary-color" (click)="closeModalDeleteQueue()">Cancelar</button>
        <button class="rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover" (click)="sendPedidoDeleteQueue()">Confirmar</button>
      </div>
    </div>
  </div>
</ng-container>
